import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnuemacsComponent } from './simple-icons-gnuemacs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnuemacsComponent ],
    exports:      [ SimpleIconsGnuemacsComponent ],
    bootstrap:    []
})
export class SimpleIconsGnuemacsModule {}
